import React, { useEffect } from 'react';
import './App.css';
import AopaCode from "./component/AopaCode";
import { gapi } from 'gapi-script';
import { useLocation, useNavigate } from 'react-router-dom';
import config from "./config";

function App() {
	const location = useLocation();
	const navigate = useNavigate();
	const username = localStorage.getItem('username');

	useEffect(() => {
		if (!username && location.pathname === '/') {
			localStorage.removeItem('username');
			navigate('/login'); 
		}
		gapi.load("client", initClient); // initialize Google API
	}, []);

	const initClient = () => {
	// Your gapi client init code here
	};

	if (username && location.pathname === '/') {
		return (
		  <div className="App">
			<AopaCode />
		  </div>
		);
	}
}

export default App;